import { Typography } from '@breetometer/components';
import { CopyIcon } from 'BreetAssets';
import { RowSection } from 'BreetComponents';
import { copyToClipboard, type CURRENCYCODETYPE, CURRENCYCONFIG, formatCurrencyAmount, formatDateTime } from 'BreetHelpers';
import { useCurrencyOutput } from 'BreetHooks';

import type { IWithdrawalsProps } from '../DialogWithdrawalHistoryDetails.helpers';
import RowBalance from './RowBalance';
import RowStatusNote from './RowStatusNote';

const WithdrawalsAddress = ({ withdrawalHistoryData }: IWithdrawalsProps) => {
	const currencyOutput = useCurrencyOutput();

	const fiatConfig = CURRENCYCONFIG[withdrawalHistoryData.currency.toUpperCase() as CURRENCYCODETYPE];

	return (
		<div className='transactiondetails_itemscontainer bg-primary-500'>
			<RowSection.Tuple
				leftLabel='Crypto Type'
				leftComponent={
					<div className='transactiondetails_value'>
						<Typography className='color-neutral-50'>{withdrawalHistoryData.doc.meta.token}</Typography>
					</div>
				}
				rightLabel='Network'
				rightComponent={
					<div className='transactiondetails_value'>
						<Typography className='color-neutral-50'>{withdrawalHistoryData.doc.meta.network}</Typography>
					</div>
				}
			/>
			<RowSection.Tuple
				leftLabel='Receive Amount'
				leftComponent={
					<div className='transactiondetails_value'>
						<Typography className='color-neutral-50'>
							{formatCurrencyAmount(withdrawalHistoryData.doc.amount - withdrawalHistoryData.doc.fee, fiatConfig.code)}
						</Typography>
					</div>
				}
				rightLabel='Label'
				rightComponent={
					<div className='transactiondetails_value'>
						<Typography className='color-neutral-50'>{withdrawalHistoryData.doc.meta.label}</Typography>
					</div>
				}
			/>
			<RowSection.Single
				label='Wallet Address'
				component={
					<div className='transactiondetails_value'>
						<Typography className='color-neutral-50'>{withdrawalHistoryData.doc.meta.walletAddress}</Typography>
						<CopyIcon
							variant='colored'
							focusable
							onClick={copyToClipboard(withdrawalHistoryData.doc.meta.walletAddress, 'Wallet Address copied successfully')}
							className='cursor_pointer hide-during-screenshot'
						/>
					</div>
				}
			/>
			<RowSection.Single
				label='Network Fee'
				component={
					<div className='transactiondetails_value'>
						<Typography className='color-neutral-50'>
							{fiatConfig.symbol}
							{currencyOutput(withdrawalHistoryData.doc.fee)}
						</Typography>
					</div>
				}
			/>

			<RowSection.Single
				label='Transaction ID'
				component={
					<div className='transactiondetails_value'>
						<Typography className='color-neutral-50'>{withdrawalHistoryData.doc._id}</Typography>
						<CopyIcon
							variant='colored'
							focusable
							onClick={copyToClipboard(withdrawalHistoryData.doc._id, 'Reference ID copied successfully')}
							className='cursor_pointer hide-during-screenshot'
						/>
					</div>
				}
			/>

			{withdrawalHistoryData.status === 'completed' && (
				<RowBalance
					symbol={fiatConfig.symbol}
					before={currencyOutput(withdrawalHistoryData.doc.balanceBefore)}
					after={currencyOutput(withdrawalHistoryData.doc.balanceAfter)}
				/>
			)}

			<RowStatusNote
				status={withdrawalHistoryData.status}
				note={withdrawalHistoryData.doc.reason}
				noteStatus={withdrawalHistoryData.status !== 'completed' ? 'error' : 'success'}
			/>

			<RowSection.Single
				label='Date'
				component={
					<div className='transactiondetails_value'>
						<Typography className='color-neutral-50'>{formatDateTime(withdrawalHistoryData.updatedAt)}</Typography>
					</div>
				}
			/>
		</div>
	);
};

export default WithdrawalsAddress;
